import { Box, Button, Typography, Paper } from "@mui/material"
import { useNavigate } from "react-router-dom"
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import StorefrontIcon from '@mui/icons-material/Storefront'

const NoSubscription = () => {
    const navigate = useNavigate();
    const handleNavigate = () => {
        window.open("https://pazaryericonverter.com/paketler", "_blank");
    };
    
    return (
        <Box sx={{ 
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
            maxWidth: 800,
            mx: 'auto',
            p: 4
        }}>
            <Box sx={{ 
                display: 'flex', 
                gap: 2, 
                mb: 2,
                justifyContent: 'center'
            }}>
                <Paper elevation={3} sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: '#e8f5e9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <AttachMoneyIcon sx={{ fontSize: 32, color: '#2e7d32' }} />
                </Paper>
                <Paper elevation={3} sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: '#fff9c4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <ShoppingCartIcon sx={{ fontSize: 32, color: '#f57f17' }} />
                </Paper>
                <Paper elevation={3} sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: '#e3f2fd',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <StorefrontIcon sx={{ fontSize: 32, color: '#1565c0' }} />
                </Paper>
            </Box>

            <Typography variant="h4" component="h1" gutterBottom sx={{ 
                fontWeight: 600,
                textAlign: 'center',
                color: '#1a237e'
            }}>
                Kullandığınız Paket Süresi Doldu
            </Typography>

            <Typography variant="h6" sx={{ 
                textAlign: 'center',
                color: '#555',
                maxWidth: 600,
                mb: 3
            }}>
                Hizmetlerimizi kullanmaya devam edebilmek için lütfen Paketinizi yenileyin.
            </Typography>

            <Button 
                variant="contained"
                size="large"
                onClick={handleNavigate}
                startIcon={<ShoppingCartIcon />}
                sx={{ 
                    minWidth: 250,
                    borderRadius: 3,
                    py: 1.5,
                    fontSize: '1.1rem',
                    textTransform: 'none',
                    background: 'linear-gradient(45deg, #1565c0 30%, #42a5f5 90%)', // Sadece buton mavi gradient
                    boxShadow: '0 3px 5px 2px rgba(33, 150, 243, .3)',
                    '&:hover': {
                        background: 'linear-gradient(45deg, #0d47a1 30%, #1565c0 90%)',
                    }
                }}
            >
                Lisansı Yenile
            </Button>
        </Box>
    );
};

export default NoSubscription;
